import React from 'react';
import { useRoleLabels } from '../contexts/RoleLabelsContext';
import { roleLabelKey } from '../roleLabels';

const DOT = {
  platform_owner:       '#a855f7',
  'broker.company':     '#6366f1',
  'broker.manager':     '#3b82f6',
  'broker.adviser':     '#94a3b8',
  'introducer.company': '#f59e0b',
  'introducer.manager': '#1d4ed8',
  'introducer.adviser': '#0f766e',
};

// Accept a full `user` object (preferred) or a legacy `role` string.
function resolve(user, role) {
  const u = user || (role ? { role } : {});
  const key = roleLabelKey(u);
  return { key, dot: DOT[key] || '#94a3b8' };
}

export default function BrokerLevelBadge({ user, role }) {
  const { labelByKey } = useRoleLabels();
  const { key, dot } = resolve(user, role);
  return (
    <span style={{ display:'inline-flex', alignItems:'center', gap:6, fontSize:12,
      fontWeight:600, padding:'3px 10px', borderRadius:20,
      background:'rgba(255,255,255,0.1)', color:'#e2e8f0' }}>
      <span style={{ width:7, height:7, borderRadius:'50%', background:dot, display:'inline-block', flexShrink:0 }} />
      {labelByKey(key)}
    </span>
  );
}

export function BrokerLevelInline({ user, role }) {
  const { labelByKey } = useRoleLabels();
  const { key, dot } = resolve(user, role);
  return (
    <span style={{ display:'flex', alignItems:'center', gap:5, fontSize:11, color:'#94a3b8' }}>
      <span style={{ width:6, height:6, borderRadius:'50%', background:dot, display:'inline-block', flexShrink:0 }} />
      {labelByKey(key)}
    </span>
  );
}

export function BrokerLevelSidebarBadge({ user, role }) {
  const { labelByKey } = useRoleLabels();
  const { key, dot } = resolve(user, role);
  return (
    <span style={{ display:'inline-flex', alignItems:'center', gap:6, fontSize:11,
      fontWeight:600, padding:'2px 8px', borderRadius:12,
      background:'rgba(255,255,255,0.08)', color:'#cbd5e0' }}>
      <span style={{ width:6, height:6, borderRadius:'50%', background:dot, display:'inline-block' }} />
      {labelByKey(key)}
    </span>
  );
}
